import AuditLogsProvider from './AuditLogsProvider';

export default AuditLogsProvider;
